import { steps } from "./signupState";

/** Signup progress (design: components/Stepper.tsx). */
export function Stepper({ current }) {
  const idx = steps.findIndex((s) => s.id === current);
  return (
    <ol className="grid grid-cols-5 gap-2" aria-label={`Step ${idx + 1} of ${steps.length}`}>
      {steps.map((s, i) => {
        const state = i < idx ? "done" : i === idx ? "current" : "todo";
        return (
          <li key={s.id} aria-current={state === "current" ? "step" : undefined} className="flex flex-col gap-2">
            <span className={state === "todo" ? "h-1 rounded-full bg-line" : "h-1 rounded-full bg-ink"} />
            <span
              className={
                state === "current"
                  ? "flex items-center gap-1 text-caption font-semibold text-ink"
                  : state === "done"
                    ? "flex items-center gap-1 text-caption font-medium text-ink/70"
                    : "flex items-center gap-1 text-caption text-muted"
              }
            >
              <span className="truncate">{s.label}</span>
            </span>
          </li>
        );
      })}
    </ol>
  );
}
